import { NRLogo } from '../ui/NRLogo';

export function LoadingScreen() {
  return (
    <div
      className="flex-1 flex items-center justify-center"
      style={{ animation: 'fadeInScale 0.5s ease-out both' }}
    >
      <NRLogo width={90} />
    </div>
  );
}
